// CLASSES
import AppConfig from "@classes/AppConfig";
import Autogiro from "./Autogiro";


export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	if (state.fields.customer_products_selected.length === 0) {
		return false;
	}

	if (state.fields.customer_autogiro.options[0].checked) {
		const replacedAccountNo = state.fields.customer_account_bank_no.split(" ").join("");
		if (replacedAccountNo <= 5 || state.fields.customer_account_bank.length === 0) {
			return false;
		}
	}
	else if (!state.fields.customer_autogiro.options[1].checked) {
		return false;
	}

	if (state.fields.customer_autogiro_single_amount && state.fields.customer_autogiro_single_amount > 0) {

		if (state.fields.customer_autogiro_single_amount < Autogiro.minimumAmountSingleDeposit) {
			return false;
		}

		if (state.autogiroSingleFundsSharesTotal !== 100) {
			return false;
		}
	}

	if (state.fields.customer_autogiro_monthly_amount && state.fields.customer_autogiro_monthly_amount > 0) {
		if (state.fields.customer_autogiro_monthly_amount < Autogiro.minimumAmountMonthlyDeposit) {
			return false;
		}

		if (state.autogiroMonthlyFundsSharesTotal !== 100) {
			return false;
		}
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Autogiro/auagfonder/Autogiro.fulfillment.js